{
  "fleet": {
    "ai": {
      "title": "GeoPoint AI",
      "description": "Kako je GeoPoint AI podešen, ko ga smije koristiti, šta pitaju i koliko košta.",
      "tab": {
        "settings": "Podešavanja",
        "access": "Pristup",
        "conversations": "Razgovori",
        "insights": "Pregled"
      }
    },
    "aiInsights": {
      "from": "Od",
      "to": "Do",
      "show": "Prikaži",
      "questions": "Pitanja",
      "cost": "Trošak",
      "errors": "Greške",
      "errorRate": "Stopa grešaka",
      "errorsHint": "Greške: {{n}}",
      "fallbackRate": "Stopa rezervnog modela",
      "avgTime": "Prosječno vrijeme odgovora",
      "p95Time": "Vrijeme 95. percentila",
      "cacheHitRate": "Pogoci keša",
      "cacheHint": "keširani ÷ ulazni tokeni",
      "questionsPerDay": "Pitanja po danu",
      "costPerDay": "Trošak po danu",
      "tokensPerDay": "Tokeni po danu (ulaz + izlaz)",
      "byAccount": "Po nalogu",
      "tools": "Najkorišteniji alati",
      "tool": "Alat",
      "calls": "Pozivi",
      "failingTools": "Alati koji najčešće ne uspiju",
      "noFailingTools": "Nijedan alat nije pao u ovom periodu.",
      "failShare": "{{errors}} od {{calls}} · {{percent}}",
      "refreshing": "Ažuriram…",
      "problem": {
        "from": "Izaberi prvi dan.",
        "to": "Izaberi posljednji dan.",
        "order": "Posljednji dan je prije prvog.",
        "span": "Izaberi period od najviše {{max}} dana."
      },
      "feedbackPerDay": "👍 / 👎 po danu",
      "day": "Dan",
      "noFeedback": "Nijedan odgovor nije ocijenjen u ovom periodu.",
      "openDown": "Otvori razgovore s 👎"
    },
    "aiFailed": {
      "title": "Neuspjelo pitanje",
      "question": "Pitanje",
      "partial": "Djelimičan odgovor",
      "noPartial": "Ništa nije odgovoreno prije greške.",
      "error": "Greška",
      "openConversation": "Otvori razgovor",
      "noConversation": "Greška se desila prije nego što je razgovor postojao, pa ga korisnik nema u istoriji."
    },
    "aiConversation": {
      "back": "Razgovori",
      "title": "Razgovor",
      "meta": "{{account}} · započet {{when}}",
      "audited": "Otvaranje je zabilježeno u Aktivnosti.",
      "openAccount": "Otvori nalog",
      "user": "Pitanje",
      "assistant": "GeoPoint AI",
      "turnError": "Neuspjelo",
      "timeline": "Tok",
      "nextAttempt": "Sljedeći pokušaj",
      "toolCall": "Poziv alata: {{name}}",
      "toolInput": "Ulaz",
      "toolOutput": "Izlaz",
      "showAll": "Prikaži sve ({{count}} znakova)",
      "turnsWithoutAnswer": "Pitanja bez odgovora",
      "failedQuestions": "Neuspjela pitanja",
      "rating": {
        "up": "Dobar odgovor",
        "down": "Loš odgovor"
      }
    },
    "aiConversations": {
      "account": "Nalog",
      "anyAccount": "Svi nalozi",
      "deletedAccount": "Obrisan nalog #{{id}}",
      "from": "Od",
      "to": "Do",
      "tool": "Alat",
      "anyTool": "Bilo koji alat",
      "all": "Svi",
      "failed": "Neuspjeli",
      "slow": "Spori",
      "slowNote": "Spori se odnosi na razgovore učitane do sada.",
      "slowHint": "Razgovori (ukupno vrijeme svih odgovora) ili neuspjela pitanja od minut ili duže, među učitanim",
      "none": "Nijedan razgovor ne odgovara ovim filterima.",
      "more": "Učitaj još",
      "fallback": "rezervni",
      "ok": "U redu",
      "errors": "Greške: {{n}}",
      "tokensTitle": "ulaz {{input}} · keš {{cached}} · izlaz {{output}} · razmišljanje {{reasoning}}",
      "col": {
        "when": "Kada",
        "account": "Nalog",
        "question": "Pitanje",
        "turns": "Koraci",
        "tokens": "Tokeni ulaz / keš / izlaz / razmišljanje",
        "cost": "Trošak",
        "model": "Model",
        "duration": "Vrijeme",
        "status": "Stanje",
        "rating": "Ocjene"
      },
      "errorKind": {
        "timeout": "Isteklo vrijeme",
        "provider": "Greška provajdera",
        "tools": "Greška alata",
        "aborted": "Prekinuto",
        "other": "Greška"
      },
      "down": "Loši odgovori",
      "downHint": "Razgovori s barem jednim 👎 (neuspjela pitanja se ne prikazuju)",
      "ratingTitle": "👍 {{up}} · 👎 {{down}}"
    },
    "aiAccess": {
      "searchPlaceholder": "Ime, e-mail ili broj naloga…",
      "hint": "Prazan limit znači podrazumijevanu vrijednost iz Podešavanja. Prekidač čuva odmah; limit se čuva svojim dugmetom.",
      "deleted": "Obrisan nalog #{{id}}",
      "chip": {
        "all": "Svi",
        "on": "Uključeni",
        "off": "Isključeni",
        "deleted": "Obrisani nalozi"
      },
      "col": {
        "account": "Nalog",
        "access": "Pristup i dnevni limit",
        "today": "Danas",
        "month": "Ovaj mjesec",
        "cost": "Trošak ovog mjeseca"
      },
      "customersHint": "Nalozi su grupisani po kupcu: menadžer i nalozi kojima upravlja, ili samostalan nalog. Model i mjesečni budžet kupca važe za sve njegove naloge; prazno = globalna podešavanja i bez vlastitog budžeta."
    },
    "aiSettings": {
      "changedElsewhere": "Podešavanja su promijenjena negdje drugdje. Učitaj ih ponovo da ih vidiš; nesačuvane izmjene bi se izgubile.",
      "reload": "Učitaj ponovo",
      "noKeyWarning": "{{providers}} će nakon čuvanja ostati bez ključa, pa GeoPoint AI preko njega ne može odgovarati.",
      "spend": "Potrošnja ovog mjeseca",
      "ofCap": "od limita {{cap}} · {{percent}}",
      "noCap": "bez mjesečnog limita",
      "routing": "Modeli i ograničenja",
      "primary": "Glavni",
      "fallback": "Rezervni",
      "noFallback": "Bez rezervnog",
      "monthlyCap": "Mjesečni limit (USD)",
      "defaultDailyLimit": "Pitanja po nalogu dnevno",
      "invalid": "Provjeri označena polja.",
      "keySaved": "Ključ sačuvan, završava na {{last4}}",
      "keyNone": "Ključ nije unesen",
      "keyRemoving": "Ključ će biti uklonjen pri čuvanju.",
      "newKey": "Novi ključ",
      "check": "Provjeri sačuvani ključ",
      "removeKey": "Ukloni ključ",
      "keepKey": "Zadrži ključ",
      "model": "Model",
      "modelNoPrice": "Za ovaj model nema cijene, pa se trošak ne bi mogao pratiti. Modeli s cijenom: {{models}}",
      "effort": "Razmišljanje",
      "effortLevel": {
        "minimal": "Minimalno",
        "low": "Nisko",
        "medium": "Srednje",
        "high": "Visoko"
      },
      "note": {
        "xai": "Za xAI tim kojem ključ pripada uključi Zero Data Retention.",
        "google": "Gemini ključ mora pripadati plaćenom projektu (uključen billing); besplatni nivo koristi podatke za treniranje.",
        "anthropic": "Napravi ključ u Anthropic konzoli, u organizaciji koja plaća."
      },
      "models": {
        "title": "Modeli (zadnjih 30 dana)",
        "provider": "Provajder",
        "questions": "Pitanja",
        "avg": "Prosječno vrijeme",
        "p90": "90. percentil",
        "perQuestion": "Po pitanju",
        "none": "Nema pitanja u zadnjih 30 dana."
      }
    },
    "ledger": {
      "title": "Evidencija i stanje",
      "description": "Evidencija vožnji iza svakog izvještaja, i da li su uređaji i Traccar ispravni.",
      "tabLedger": "Evidencija",
      "tabHealth": "Stanje",
      "status": "Evidencija",
      "running": "Obnova u toku",
      "idle": "Miruje",
      "since": "Pokriva svaki dan od {{day}}",
      "noStart": "Početni dan nije postavljen",
      "progress": "{{done}} od {{total}} gotovo · {{percent}}",
      "coverage": "Pokrivenost",
      "coverageHint": "Dani koje evidencija ima sačuvane za svako vozilo. Popunjeno zeleno polje je sačuvan dan; polje sa okvirom i kosom crtom je dan koji nedostaje.",
      "cellBuilt": "{{day}}: sačuvan",
      "cellMissing": "{{day}}: nedostaje",
      "show": "Prikaži",
      "from": "Od",
      "to": "Do",
      "noCoverage": "Nema sačuvanih dana u ovom periodu.",
      "built": "sačuvan",
      "missing": "nedostaje",
      "missingCount": "{{n}} nedostaje",
      "rebuild": "Obnova",
      "rebuildHint": "Ponovo izračunaj vožnje i ukupne iznose izvještaja jednog vozila za najviše {{max}} dana. U jednom trenutku radi samo jedna obnova.",
      "vehicle": "Vozilo",
      "rebuildButton": "Obnovi…",
      "problem": {
        "from": "Izaberi početni dan.",
        "to": "Izaberi završni dan.",
        "order": "Završni dan je prije početnog.",
        "span": "Najviše {{max}} dana odjednom.",
        "future": "Današnji dan se još ne čuva. Izaberi juče ili ranije.",
        "beforeStart": "Evidencija počinje poslije tog dana."
      },
      "confirmTitle": "Obnoviti vozilo {{name}}?",
      "confirmBody": "Vožnje i ukupni iznosi izvještaja od {{from}} do {{to}} ({{n}} dana) ponovo se računaju iz sačuvanih pozicija, pa se izvještaji za te dane mogu promijeniti. Napredak se prikazuje ovdje dok obnova traje.",
      "confirm": "Obnovi",
      "switchedOff": "Evidencija je isključena na ovom Traccaru, pa se ništa ne može obnoviti.",
      "vehicleHint": "Prikazana su samo vozila koja su se javljala."
    },
    "health": {
      "silent": "Uređaji koji se ne javljaju",
      "silentWeek": "Duže od 7 dana",
      "silentDay": "Od 24 sata do 7 dana",
      "noneSilent": "Svi uređaji su se javili u posljednja 24 sata.",
      "dataUsage": "Potrošnja podataka po vozilu",
      "dataUsageOf": "Podaci po danu — {{name}}",
      "vehicle": "Vozilo",
      "perDay": "Po danu",
      "total": "Ukupno",
      "statistics": "Dnevna statistika Traccara",
      "messagesReceived": "Primljene poruke",
      "messagesStored": "Sačuvane poruke",
      "activeDevices": "Aktivni uređaji",
      "day": "Dan"
    },
    "groups": {
      "tab": "Grupe",
      "title": "Grupe",
      "description": "Grupe vozila i nalozi koji vide svaku grupu.",
      "searchPlaceholder": "Naziv grupe…",
      "col": {
        "name": "Grupa",
        "vehicles": "Vozila",
        "accounts": "Nalozi"
      },
      "detail": {
        "title": "Grupa",
        "vehicles": "Vozila u ovoj grupi",
        "accounts": "Nalozi koji vide ovu grupu",
        "moveIn": "Premjesti ovdje",
        "moveOut": "Ukloni iz grupe",
        "inGroup": "sada u {{name}}",
        "moveHint": "Premještanjem ovdje vozilo izlazi iz grupe u kojoj je sada."
      }
    },
    "zones": {
      "tab": "Zone",
      "title": "Zone",
      "description": "Sve zone nacrtane u traccar-web, ovdje samo za pregled, i s kim je svaka podijeljena.",
      "searchPlaceholder": "Naziv zone…",
      "none": "Još nema zona",
      "sharedWith": "Podijeljena s:",
      "sharedWithNobody": "niko",
      "groupName": "grupa {{name}}",
      "shape": {
        "circle": "Krug",
        "polygon": "Područje",
        "line": "Ruta",
        "unknown": "Ne može se nacrtati"
      }
    },
    "vehicles": {
      "title": "Vozila i uređaji",
      "description": "Svako vozilo i njegov uređaj: da li se javlja, ograničenja i brojači, i ko ga vidi.",
      "searchPlaceholder": "Tablica, IMEI, model ili grupa…",
      "noGroup": "Bez grupe",
      "noLimit": "Bez ograničenja",
      "ago": "prije {{age}}",
      "never": "nikad",
      "card": {
        "total": "Vozila",
        "online": "Trenutno na vezi",
        "silent": "Bez javljanja > 24 h",
        "noFix": "Bez pozicije danas",
        "dataToday": "Podaci danas"
      },
      "chip": {
        "all": "Sva",
        "online": "Na vezi",
        "silent": "Bez javljanja > 24 h",
        "noFix": "Bez pozicije danas",
        "noGroup": "Bez grupe"
      },
      "col": {
        "name": "Vozilo",
        "group": "Grupa",
        "status": "Posljednji zapis",
        "speedLimit": "Ograničenje brzine",
        "fuel": "Gorivo",
        "odometer": "Kilometraža",
        "accounts": "Nalozi",
        "data7d": "Podaci 7 dana"
      },
      "status": {
        "online": "Na vezi",
        "offline": "Van veze",
        "unknown": "Nepoznato"
      },
      "fuel": {
        "trusted": "Pouzdano",
        "approx": "Približno",
        "none": "Bez podataka o gorivu",
        "unset": "Nije postavljeno"
      },
      "detail": {
        "title": "Vozilo",
        "settings": "Podešavanja",
        "speedLimit": "Ograničenje brzine (km/h)",
        "speedLimitHint": "{{min}}–{{max}} km/h, ili prazno za bez ograničenja.",
        "fuelQuality": "Kvalitet podataka o gorivu",
        "fuelHint": "Koliko GeoPoint AI i izvještaji smiju vjerovati očitavanjima goriva ovog vozila.",
        "accumulators": "Kilometraža i moto-sati",
        "odometer": "Kilometraža (km)",
        "hours": "Moto-sati (h)",
        "now": "Trenutno {{value}}",
        "accumulatorsInvalid": "Unesi broj 0 ili veći.",
        "accumulatorsSave": "Izmijeni…",
        "accumulatorsConfirmTitle": "Izmijeniti brojače vozila {{name}}?",
        "accumulatorsConfirmBody": "Mijenjaju se ukupni iznosi budućih izvještaja: kilometraža i moto-sati dalje se broje od novih vrijednosti. Već poslani izvještaji ostaju kakvi su bili.",
        "accumulatorsConfirm": "Izmijeni brojače",
        "changeLine": "{{field}}: {{from}} → {{to}}",
        "accumulatorsCanNote": "Na vozilima sa CAN kilometražom izvještaji čitaju kilometražu samog vozila, pa ova izmjena možda neće promijeniti kilometražu u izvještajima.",
        "noRecordYet": "Ovo vozilo još nije poslalo nijedan zapis, pa se njegovi brojači ne mogu mijenjati.",
        "group": "Grupa",
        "move": "Premjesti",
        "lastFix": "Posljednja pozicija",
        "lastRecords": "Posljednji primljeni zapisi",
        "noRecords": "Još nema primljenih zapisa.",
        "fixTime": "Vrijeme pozicije",
        "position": "Pozicija",
        "speed": "Brzina",
        "fix": "Pozicija",
        "valid": "ispravna",
        "invalid": "neispravna",
        "accounts": "Nalozi koji ga vide"
      }
    },
    "accounts": {
      "tokens": {
        "title": "Tokeni aplikacije klijenta",
        "description": "Omogućava aplikaciji ovog klijenta (npr. damis) da čita i preimenuje vozila preko GeoPointa.",
        "empty": "Još nema tokena.",
        "new": "Novi token",
        "newTitle": "Novi token klijenta",
        "newBody": "Nazovite ga po aplikaciji koja će ga koristiti.",
        "label": "Naziv",
        "create": "Kreiraj",
        "createdTitle": "Kopirajte token sada",
        "createdBody": "Prikazuje se samo ovaj put. Sačuvajte ga kao tajnu aplikacije (npr. GPS_TOKEN u damisu).",
        "copy": "Kopiraj",
        "copyFailed": "Kopiranje nije uspjelo. Označite token i kopirajte ga ručno.",
        "copied": "Token kopiran",
        "done": "Gotovo",
        "created": "Kreiran {{day}}",
        "lastUsed": "zadnja upotreba {{day}}",
        "neverUsed": "nikad korišten",
        "revoked": "Opozvan",
        "revoke": "Opozovi",
        "revokeTitle": "Opozvati {{label}}?",
        "revokeBody": "Aplikacija koja ga koristi prestaje raditi dok ne dobije novi token."
      },
      "title": "Nalozi",
      "description": "Svi Traccar nalozi: ko može da se prijavi, šta vidi i da li koristi GeoPoint AI.",
      "searchPlaceholder": "Ime ili e-mail…",
      "on": "Uključen",
      "off": "Isključen",
      "noExpiry": "Ne ističe",
      "questionsToday": "{{n}} danas",
      "card": {
        "total": "Nalozi",
        "disabled": "Isključeni",
        "admins": "Administratori i menadžeri",
        "milo": "GeoPoint AI uključen"
      },
      "chip": {
        "all": "Svi",
        "on": "Uključeni",
        "off": "Isključeni",
        "admins": "Administratori i menadžeri",
        "milo": "GeoPoint AI uključen"
      },
      "col": {
        "name": "Ime",
        "role": "Uloga",
        "vehicles": "Vozila",
        "groups": "Grupe",
        "status": "Nalog",
        "expiry": "Ističe",
        "milo": "GeoPoint AI"
      },
      "role": {
        "admin": "Administrator",
        "manager": "Menadžer",
        "user": "Korisnik",
        "readonly": "Samo čitanje"
      },
      "detail": {
        "title": "Nalog",
        "vehicles": "Vozila",
        "groups": "Grupe",
        "access": "Prijava",
        "accountSwitch": "Nalog uključen",
        "miloSwitch": "GeoPoint AI uključen",
        "dailyLimit": "Pitanja dnevno",
        "dailyLimitDefault": "podrazumijevano",
        "dailyLimitInvalid": "Cijeli broj do 1000, ili prazno za podrazumijevanu vrijednost.",
        "conversations": "Razgovori",
        "offTitle": "Isključiti nalog {{name}}?",
        "offBody": "Korisnik se više ne može prijaviti u traccar-web ni u aplikaciju, a izvještaji i upozorenja mu ne stižu, dok se nalog ponovo ne uključi.",
        "offConfirm": "Isključi",
        "serviceAccount": "Traccar nalog samog echo servisa: njegovo isključivanje bi administraciji voznog parka presjeklo vezu s Traccarom. Ako baš moraš, promijeni ga u traccar-web."
      }
    },
    "sims": {
      "title": "SIM podaci",
      "description": "Šta 1NCE naplaćuje za svaku SIM karticu uređaja, dan po dan, i koliko joj je ostalo od paketa.",
      "syncNow": "Sinhronizuj sada",
      "syncing": "Sinhronizacija…",
      "live": "Uživo",
      "liveAt": "Uživo · {{time}}",
      "lastRun": "Posljednja sinhronizacija {{when}} · {{status}} · {{count}} SIM kartica",
      "neverRun": "Još nije sinhronizovano. Prva sinhronizacija preuzima istoriju svake SIM kartice.",
      "running": "Sinhronizacija u toku…",
      "status": {
        "ok": "uspješno",
        "partial": "djelimično",
        "failed": "neuspješno",
        "running": "u toku"
      },
      "openSince": "Otvorena od {{when}} — još nije naplaćena",
      "closed": "Zatvorena {{when}}",
      "unknownSession": "—",
      "lastError": "Posljednja provjera nije uspjela: {{error}}",
      "days": {
        "day": "Dan",
        "volume": "Potrošeno",
        "sent": "Poslato",
        "received": "Primljeno",
        "state": "Stanje",
        "empty": "Nema dana u ovom periodu."
      },
      "state": {
        "confirmed": "Potvrđeno",
        "checking": "U provjeri",
        "changed": "{{change}} pri ponovnoj provjeri"
      },
      "summary": {
        "used": "Potrošeno za {{period}}: {{used}}",
        "perVehicle": "Po vozilu dnevno: {{value}}",
        "low": "Ispod 20 % preostalo: {{count}}",
        "open": "Još nije naplaćeno: {{count}}"
      },
      "card": {
        "leftOf": "preostalo od {{total}}",
        "lasts": "Traje do ≈ {{year}}, duže od roka SIM kartice ({{expiry}})",
        "runsOut": "Potrošiće se ≈ {{year}}, prije isteka SIM kartice ({{expiry}})",
        "lastsNoExpiry": "Traje do ≈ {{year}}",
        "noEstimate": "Nema skorašnje potrošnje za procjenu",
        "used": "{{used}} za {{period}}, {{perDay}} dnevno",
        "bars": "Podaci po danu: {{name}}",
        "notFinal": "nije konačno",
        "open": "Otvori SIM karticu: {{name}}",
        "details": "Detalji"
      },
      "noVehicles": "Nijedna SIM kartica još nije u vozilu.",
      "spares": "Rezervne SIM kartice, nisu u vozilu: {{count}}",
      "spareLeft": "{{left}} od {{total}} preostalo",
      "by": {
        "day": "Dani",
        "week": "Sedmice",
        "month": "Mjeseci"
      },
      "periods": {
        "day": "posljednjih 30 dana",
        "week": "posljednjih 12 sedmica",
        "month": "posljednjih 12 mjeseci"
      },
      "panel": {
        "phone": "Broj telefona",
        "phoneHint": "SMS komande uređaju idu na ovaj broj",
        "imei": "IMEI uređaja",
        "imsi": "IMSI",
        "iccid": "ICCID",
        "ip": "IP adresa",
        "status": "Status",
        "activated": "Aktivirana",
        "validUntil": "Važi do",
        "left": "Preostalo podataka",
        "leftOf": "{{left}} od {{total}}",
        "session": "Sesija",
        "usage": "Potrošnja",
        "week": "Sedmica",
        "month": "Mjesec",
        "weekOf": "Sedmica od {{date}}"
      },
      "heatmap": {
        "title": "Potrošnja po vozilu",
        "vehicle": "Vozilo",
        "total": "Ukupno",
        "cell": "{{name}}, {{period}}: {{value}}",
        "noData": "nema podataka",
        "zero": "0",
        "upTo": "do {{value}}"
      }
    },
    "nav": {
      "title": "Administracija voznog parka",
      "accounts": "Nalozi",
      "vehicles": "Vozila",
      "groups": "Grupe i zone",
      "ledger": "Evidencija i stanje",
      "sims": "SIM podaci",
      "ai": "GeoPoint AI"
    },
    "common": {
      "eyebrow": "Administracija voznog parka",
      "timesIn": "Sva vremena: {{tz}}",
      "unavailable": "nedostupno",
      "unavailableHint": "Trenutno se ne može učitati",
      "loading": "Učitava se…",
      "retry": "Pokušaj ponovo",
      "readOnly": "Prikazani su posljednji učitani podaci. Izmjene su pauzirane dok se veza ne vrati.",
      "openInTraccar": "Otvori u traccar-web",
      "search": "Pretraga",
      "cancel": "Otkaži",
      "save": "Sačuvaj",
      "saving": "Čuva se…",
      "on": "Uključeno",
      "off": "Isključeno",
      "none": "Ništa",
      "all": "Sve",
      "noMatch": "Ništa ne odgovara upitu „{{query}}”",
      "noMatchHint": "Pokušaj s imenom, tablicom, e-mailom ili IMEI brojem.",
      "empty": "Ovdje još nema ništa",
      "link": "Poveži",
      "unlink": "Ukloni vezu",
      "locked": "Zaključano",
      "nothingToLink": "Nema više šta da se poveže",
      "lockedWhy": "Sopstveni servisni nalog echo servisa",
      "pick": "Izaberi…",
      "noneLinked": "Ništa nije povezano",
      "back": "Nazad"
    },
    "errors": {
      "traccar_not_connected": "Traccar još nije povezan s echo servisom.",
      "traccar_unavailable": "Traccar ne odgovara. Prikazani su posljednji učitani podaci; pokušaj ponovo za minut.",
      "traccar_auth": "Traccar je odbio echo token. Veza s Traccarom treba novi token.",
      "milo_not_connected": "GeoPoint AI nije povezan s echo servisom: nedostaje njegova adresa ili administratorski token, ili nisu prihvaćeni.",
      "milo_unavailable": "GeoPoint AI ne odgovara. Pokušaj ponovo za minut.",
      "not_found": "Ovo više ne postoji. Lista je osvježena.",
      "validation": "Neke vrijednosti nisu prihvaćene. Provjeri obrazac i pokušaj ponovo.",
      "rebuild_running": "Obnova je već u toku. Pokušaj ponovo kad se završi.",
      "once_not_connected": "Podaci SIM kartica još nisu povezani s echo servisom: nedostaje 1NCE API ključ.",
      "once_unavailable": "1NCE ne odgovara. Prikazani su brojevi iz posljednje sinhronizacije; pokušaj ponovo za minut.",
      "once_auth": "1NCE je odbio echo API ključ. Veza s 1NCE-om treba novi ključ.",
      "sync_running": "Sinhronizacija SIM kartica je već u toku. Brojevi će se pojaviti kad se završi.",
      "network": "echo nije dostupan. Provjeri vezu i pokušaj ponovo.",
      "unknown": "Nešto nije u redu. Pokušaj ponovo."
    },
    "warnings": {
      "title": "Neki dijelovi nisu učitani",
      "parts": "Nedostaje: {{parts}}",
      "part": {
        "accounts": "imena naloga",
        "links": "veze naloga, vozila i grupa",
        "groups": "nazivi grupa",
        "devices": "nazivi vozila",
        "positions": "posljednji zapisi",
        "dataUsage": "potrošnja podataka",
        "milo": "GeoPoint AI",
        "ledgerStatus": "stanje evidencije",
        "ledgerCoverage": "pokrivenost evidencije",
        "statistics": "statistika Traccara",
        "zoneSharing": "dijeljenje zona",
        "customers": "kupci (svaki nalog je prikazan kao svoj kupac)"
      }
    },
    "notConnected": {
      "traccarTitle": "Traccar nije povezan",
      "traccarBody": "echo treba TRACCAR_URL i TRACCAR_SERVICE_TOKEN (token Traccar administratorskog naloga echo-service). Postavi oba u okruženju echo servisa i ponovo ga pokreni.",
      "miloTitle": "GeoPoint AI nije povezan",
      "miloBody": "echo treba MILO_URL i MILO_ADMIN_TOKEN, a Milo isti MILO_ADMIN_TOKEN. Postavi ih i ponovo pokreni oba servisa.",
      "onceTitle": "SIM podaci nisu povezani",
      "onceBody": "echo treba ONCE_CLIENT_ID i ONCE_CLIENT_SECRET (ključ 1NCE Management API-ja). Postavi oba u okruženju echo servisa i ponovo ga pokreni."
    },
    "aiCustomers": {
      "unknown": "Kupac #{{id}}",
      "deleted": "Obrisan kupac #{{id}}",
      "members": "Nalozi: {{n}} · GeoPoint AI uključen: {{enabled}}",
      "provider": "Model kupca",
      "model": "Model",
      "budget": "Mjesečni budžet (USD)",
      "noBudget": "Bez budžeta",
      "globalModel": "Globalni model",
      "globalModelIs": "Globalni model ({{model}} · {{effort}})",
      "noKey": "{{provider}} (nema ključa)",
      "spendOfBudget": "{{spent}} od {{budget}} · {{percent}}",
      "spendNoBudget": "{{spent}} ovog mjeseca · bez vlastitog budžeta",
      "questions": "Pitanja ovog mjeseca: {{n}}",
      "noLonger": "Ovaj nalog više nije kupac (sada njime upravlja drugi nalog): njegov model i budžet se ne primjenjuju.",
      "state": {
        "near": "Blizu budžeta",
        "reached": "Budžet potrošen: pauzirano do kraja mjeseca"
      },
      "invalid": {
        "provider": "{{provider}} nema ključa, pa ovaj kupac radi na globalnom modelu. Izaberi drugi model ili globalni.",
        "model": "Za ovaj model nema cijene. Izaberi model s cijenom.",
        "effort": "Izaberi nivo razmišljanja.",
        "budget": "Budžet je iznos u USD od 0 do 100.000; prazno = bez vlastitog budžeta."
      },
      "lock": {
        "customers": "Kupci nisu učitani, pa se model i budžet sada ne mogu mijenjati.",
        "unknown": "Ovaj kupac još nije na spisku kupaca. Učitaj ponovo da ga izmijeniš.",
        "deleted": "Nalog ovog kupca je obrisan; njegova podešavanja više ne važe.",
        "settings": "Podešavanja GeoPoint AI nisu učitana, pa se model ne može izabrati."
      },
      "noMembers": "Nema naloga"
    }
  },
  "error500": {
    "title": "500 Greška na serveru",
    "subtitle": "Nešto je pošlo po zlu sa naše strane",
    "description": "Izvinjavamo se na neprijatnosti. Došlo je do interne greške na serveru i nismo mogli da obradimo vaš zahtjev. Naš tim je obaviješten.",
    "tryAgain": "Pokušaj ponovo",
    "goHome": "Idi na početnu",
    "errorCode": "Kod greške"
  },
  "sidebar": {
    "title": "Bočna Traka",
    "mobileDescription": "Prikazuje mobilnu bočnu traku.",
    "toggle": "Preklopi Bočnu Traku"
  },
  "nav": {
    "board": "Tabla",
    "planner": "Planer",
    "map": "Mapa uživo",
    "exceptions": "Izuzeci",
    "documents": "Papiri",
    "buyers": "Kupci",
    "fleet": "Vozni park",
    "billing": "Fakturisanje",
    "outbox": "Poslato",
    "roadmap": "Plan razvoja",
    "dashboard": "Početna",
    "counters": "Brojači",
    "users": "Korisnici",
    "activityHistory": "Aktivnost",
    "profile": "Profil",
    "settings": "Podešavanja",
    "collapse": "Skupi",
    "demo": "Demo",
    "logout": "Odjava",
    "section": {
      "dispatch": "Otprema",
      "book": "Evidencija",
      "admin": "Administracija"
    }
  },
  "theme": {
    "light": "Svijetlo",
    "dark": "Tamno",
    "system": "Sistem"
  },
  "language": {
    "en": "English",
    "es": "Español",
    "sr": "Srpski"
  },
  "common": {
    "user": "Korisnik",
    "cancel": "Otkaži",
    "save": "Sačuvaj",
    "dismiss": "Zatvori"
  },
  "login": {
    "title": "Dobrodošli nazad",
    "description": "Unesite vaše podatke za prijavu na vaš nalog",
    "identifier": {
      "username": "Korisničko ime",
      "email": "Email",
      "both": "Korisničko ime ili email",
      "placeholder": "Unesite {{field}}"
    },
    "password": {
      "label": "Lozinka",
      "placeholder": "Unesite vašu lozinku"
    },
    "button": "Prijavi se",
    "button.loading": "Prijavljivanje...",
    "error": {
      "identifierRequired": "{{field}} je obavezno polje",
      "passwordLength": "Lozinka mora imati najmanje 6 karaktera",
      "failed": "Prijava nije uspjela",
      "unknown": "Došlo je do neočekivane greške"
    },
    "forgotPassword": "Zaboravili ste lozinku?",
    "noAccount": "Nemate nalog?",
    "signUp": "Registrujte se"
  },
  "invitation": {
    "title": "Završite Vašu Registraciju",
    "description": "Postavite vašu lozinku da aktivirate vaš nalog",
    "username": "Korisničko ime",
    "password": "Lozinka",
    "passwordPlaceholder": "Unesite vašu lozinku",
    "confirmPassword": "Potvrdite Lozinku",
    "confirmPasswordPlaceholder": "Potvrdite vašu lozinku",
    "button": "Postavi Lozinku i Aktiviraj",
    "button.loading": "Postavljanje...",
    "invalidTitle": "Nevažeća Pozivnica",
    "goToLogin": "Idi na Prijavu",
    "resetPassword": {
      "title": "Resetuj Vašu Lozinku",
      "description": "Unesite novu lozinku za vaš nalog",
      "button": "Resetuj Lozinku",
      "button.loading": "Resetovanje..."
    },
    "error": {
      "noToken": "Token za pozivnicu nije proslijeđen",
      "invalidToken": "Nevažeći ili istekao token za pozivnicu",
      "passwordLength": "Lozinka mora imati najmanje 8 karaktera",
      "passwordMismatch": "Lozinke se ne poklapaju",
      "failed": "Neuspješno postavljanje lozinke. Molimo pokušajte ponovo."
    }
  },
  "profile": {
    "title": "Moj Nalog",
    "subtitle": "Upravljajte profilom i bezbjednosnim podešavanjima",
    "edit": "Izmijeni",
    "verified": "Verifikovan",
    "updateSuccess": "Profil uspješno ažuriran",
    "updateError": "Greška pri ažuriranju profila",
    "info": {
      "title": "Informacije o Profilu",
      "description": "Detalji vašeg naloga"
    },
    "field": {
      "name": "Puno Ime",
      "username": "Korisničko Ime",
      "email": "Email",
      "memberSince": "Član Od"
    },
    "editModal": {
      "title": "Izmijeni Profil",
      "description": "Ažurirajte informacije vašeg profila"
    },
    "security": {
      "title": "Promijeni Lozinku",
      "description": "Ažurirajte lozinku da biste zaštitili vaš nalog",
      "currentPassword": "Trenutna Lozinka",
      "newPassword": "Nova Lozinka",
      "confirmPassword": "Potvrdite Novu Lozinku",
      "passwordMismatch": "Lozinke se ne poklapaju",
      "passwordInvalid": "Lozinka ne ispunjava zahtjeve",
      "changeSuccess": "Lozinka uspješno promijenjena. Ostale sesije su zatvorene.",
      "changeError": "Greška pri promjeni lozinke",
      "changeButton": "Promijeni Lozinku"
    },
    "sessions": {
      "currentSession": "Trenutna Sesija",
      "current": "Trenutna",
      "device": "Uređaj",
      "ip": "IP Adresa",
      "lastActive": "Posljednja Aktivnost",
      "now": "Sada",
      "unknown": "Nepoznato",
      "otherSessions": "Ostale Sesije",
      "otherDescription": "Sesije aktivne na drugim uređajima",
      "revokeAll": "Opozovi Sve",
      "revoke": "Opozovi",
      "revokeSuccess": "Sesija uspješno opozvana",
      "revokeError": "Greška pri opozivanju sesije",
      "revokeAllSuccess": "Sve ostale sesije su zatvorene",
      "revokeAllError": "Greška pri opozivanju sesija",
      "noOtherSessions": "Nema drugih aktivnih sesija",
      "lastActiveAt": "Posljednja aktivnost {{time}}",
      "neverActive": "Nikada aktivna",
      "confirmRevokeAll": {
        "title": "Opozovi Sve Sesije",
        "description": "Ovo će zatvoriti sve ostale sesije. Ostaćete prijavljeni na ovom uređaju."
      },
      "time": {
        "daysAgo": "prije {{count}} d",
        "hoursAgo": "prije {{count}} h",
        "justNow": "upravo sada",
        "minutesAgo": "prije {{count}} min"
      },
      "unknownBrowser": "Nepoznat pregledač",
      "unknownDevice": "Nepoznat uređaj"
    }
  },
  "settings": {
    "title": "Podešavanja",
    "subtitle": "Upravljajte preferencama vaše aplikacije",
    "theme": "Tema",
    "themeDescription": "Izaberite vašu željenu temu",
    "language": "Jezik",
    "languageDescription": "Izaberite vaš željeni jezik"
  },
  "users": {
    "title": "Korisnici",
    "button": {
      "add": "Dodaj Korisnika",
      "resetPassword": "Resetuj Lozinku",
      "resendInvitation": "Pošalji Pozivnicu Ponovo",
      "deactivate": "Deaktiviraj",
      "activate": "Aktiviraj",
      "demoteFromAdmin": "Ukloni ulogu administratora",
      "promoteToAdmin": "Unapredi u administratora",
      "delete": "Obriši"
    },
    "table": {
      "username": "Korisničko ime",
      "email": "Email",
      "name": "Ime",
      "role": "Uloga",
      "status": "Status",
      "lastLogin": "Posljednja Prijava",
      "created": "Kreiran",
      "actions": "Akcije",
      "noResults": "Nema pronađenih korisnika",
      "roles": "Uloge"
    },
    "status": {
      "active": "Aktivan",
      "inactive": "Neaktivan"
    },
    "date": {
      "never": "Nikad"
    },
    "actions": {
      "label": "Akcije",
      "copyId": "Kopiraj ID korisnika",
      "editUser": "Izmijeni korisnika",
      "openMenu": "Otvori meni",
      "viewDetails": "Prikaži detalje"
    },
    "filter": {
      "allRoles": "Sve Uloge",
      "allStatus": "Svi Statusi"
    },
    "search": {
      "placeholder": "Pretraži po korisničkom imenu..."
    },
    "error": {
      "create": "Neuspješno kreiranje korisnika",
      "delete": "Neuspješno brisanje korisnika",
      "resetPassword": "Neuspješno resetovanje lozinke",
      "resendInvitation": "Neuspješno slanje pozivnice",
      "activate": "Neuspješno aktiviranje korisnika",
      "demote": "Uklanjanje uloge korisniku nije uspjelo",
      "promote": "Unapređenje korisnika nije uspjelo",
      "deactivate": "Neuspješno deaktiviranje korisnika"
    },
    "role": {
      "USER": "Korisnik",
      "ADMIN": "Administrator",
      "SUPERADMIN": "Super Administrator"
    },
    "modal": {
      "add": {
        "title": "Dodaj Novog Korisnika",
        "description": "Kreirajte novi korisnički nalog. Biće generisan link za pozivnicu.",
        "name": "Ime",
        "namePlaceholder": "Unesite puno ime...",
        "email": "Email",
        "emailPlaceholder": "Unesite email...",
        "emailOptional": "Email (opciono)",
        "identifierHint": "Unesite korisničko ime, email ili oboje — korisnik se prijavljuje onim što postavite.",
        "username": "Korisničko ime",
        "usernamePlaceholder": "Unesite korisničko ime...",
        "role": "Uloga",
        "password": "Lozinka (opciono)",
        "passwordPlaceholder": "Ostavite prazno za slanje linka za pozivnicu",
        "passwordHint": "Ako se ostavi prazno, biće generisan link za pozivnicu kako bi korisnik postavio svoju lozinku.",
        "button": "Kreiraj Korisnika",
        "rolePlaceholder": "Izaberite ulogu"
      },
      "invitation": {
        "copied": "Link je kopiran",
        "copyFailed": "Kopiranje nije uspjelo. Kopirajte link ručno.",
        "title": "Link za Pozivnicu",
        "message": "Podijelite ovaj link sa korisnikom da završi svoju registraciju.",
        "emailSent": "Pozivnica je poslata na {{email}}.",
        "emailFailed": "Pozivnica nije mogla biti poslata na {{email}}. Pošaljite link ispod ručno.",
        "button": {
          "copy": "Kopiraj Link",
          "done": "Gotovo"
        }
      },
      "deactivate": {
        "title": "Deaktiviraj Korisnika",
        "message": "Da li ste sigurni da želite da deaktivirate {{username}}?",
        "button": "Deaktiviraj"
      },
      "selfReset": {
        "title": "Resetuj Vašu Lozinku",
        "message": "Upravo ćete resetovati svoju lozinku. Bićete odjavljeni i moraćete koristiti link za pozivnicu da se ponovo prijavite.",
        "button": "Resetuj Lozinku"
      },
      "button": {
        "cancel": "Otkaži"
      },
      "delete": {
        "title": "Obriši Korisnika",
        "message": "Ovo trajno briše {{username}} i ne može se poništiti. Nalog se odjavljuje svuda i više nikada ne može da se prijavi, a njegovo korisničko ime i email postaju slobodni za nekog drugog. Da samo uklonite pristup, deaktivirajte ga.",
        "confirm": "Upišite {{username}} da potvrdite",
        "button": "Obriši Korisnika"
      }
    },
    "card": {
      "total": "ukupno"
    },
    "pagination": {
      "of": "od",
      "page": "Strana",
      "rowsPerPage": "Redova po strani"
    }
  },
  "counters": {
    "title": "Brojači",
    "description": "Upravljajte vašim brojačima",
    "newCounter": "Novi Brojač",
    "empty": "Još nema brojača. Kreirajte jedan da počnete!",
    "lastUpdated": "Posljednje ažurirano:",
    "modal": {
      "title": "Kreiraj Novi Brojač",
      "description": "Unesite ime za vaš novi brojač.",
      "nameLabel": "Ime Brojača",
      "namePlaceholder": "Unesite ime brojača...",
      "cancel": "Otkaži",
      "create": "Kreiraj"
    },
    "clearAll": "Obriši sve",
    "clearAllModal": {
      "cancel": "Otkaži",
      "confirm": "Obriši sve",
      "description": "Da li ste sigurni da želite da obrišete svih {{count}} brojača? Ova radnja se ne može poništiti.",
      "title": "Obriši sve brojače"
    },
    "error": {
      "create": "Kreiranje brojača nije uspjelo",
      "decrement": "Umanjenje brojača nije uspjelo",
      "delete": "Brisanje brojača nije uspjelo",
      "deleteAll": "Brisanje svih brojača nije uspjelo",
      "increment": "Uvećanje brojača nije uspjelo",
      "reset": "Resetovanje brojača nije uspjelo"
    },
    "loadError": "Brojači nisu mogli da se učitaju.",
    "noResults": "Nijedan brojač ne odgovara vašoj pretrazi.",
    "search": "Pretraži brojače...",
    "toast": {
      "incremented": "Brojač je uvećan"
    },
    "total": "ukupno"
  },
  "activity": {
    "table": {
      "timestamp": "Vrijeme",
      "action": "Akcija",
      "entityType": "Tip Entiteta",
      "user": "Korisnik",
      "ip": "IP Adresa",
      "status": "Status",
      "noResults": "Nema pronađenih zapisa aktivnosti"
    },
    "status": {
      "success": "Uspješno",
      "failed": "Neuspješno"
    },
    "filter": {
      "clear": "Obriši",
      "allActions": "Sve Akcije",
      "allEntities": "Svi Tipovi Entiteta",
      "allStatus": "Svi Statusi"
    },
    "entityType": {
      "session": "Sesija",
      "user": "Korisnik",
      "counter": "Brojač"
    },
    "action": {
      "LOGIN": "Prijava",
      "LOGIN_FAILED": "Neuspješna Prijava",
      "LOGOUT": "Odjava",
      "LOGOUT_ALL": "Odjava Svih",
      "TOKEN_REFRESH": "Obnova Tokena",
      "CREATE": "Kreiranje",
      "UPDATE": "Ažuriranje",
      "DELETE": "Brisanje",
      "PASSWORD_SET": "Postavljanje Lozinke",
      "PASSWORD_CHANGE": "Promjena Lozinke",
      "PASSWORD_RESET": "Resetovanje Lozinke",
      "REGISTER": "Registracija",
      "EMAIL_VERIFY": "Verifikacija Emaila",
      "VIEW": "Pregled",
      "RESEND_VERIFICATION": "Ponovno Slanje Verifikacije"
    },
    "search": {
      "placeholder": "Pretraži po korisničkom imenu, IP, entitetu..."
    },
    "button": {
      "details": "Detalji"
    },
    "modal": {
      "title": "Detalji Aktivnosti"
    },
    "details": {
      "error": "Greška",
      "previousState": "Prethodno Stanje",
      "newState": "Novo Stanje",
      "metadata": "Metapodaci",
      "userAgent": "User Agent"
    },
    "pagination": {
      "of": "od",
      "page": "Strana",
      "rowsPerPage": "Redova po strani"
    }
  },
  "activityHistory": {
    "title": "Istorija Aktivnosti",
    "description": "Pregledajte sistemske revizijske logove i aktivnost korisnika",
    "card": {
      "total": "unosa"
    }
  },
  "toast": {
    "sessionExpired": "Sesija je istekla. Molimo prijavite se ponovo.",
    "deviceMismatch": "Ova sesija pripada drugom uređaju. Molimo prijavite se ponovo.",
    "rateLimited": "Previše zahtjeva. Molimo pokušajte ponovo kasnije.",
    "reconnecting": "Ponovno povezivanje…",
    "unreachable": "Nismo mogli da pristupimo serveru — možda se ponovo pokreće. Ništa nije sačuvano; pokušajte ponovo za trenutak."
  },
  "backend": {
    "accountLocked": "Previše neuspješnih pokušaja prijave. Pokušajte ponovo za {{seconds}} sekundi",
    "accountLockedTitle": "Nalog je privremeno zaključan",
    "badRequest": "Zahtjev nije ispravan",
    "cannotAssignCustomerRole": "Uloga korisnika-kupca ne može da se dodeli nalozima kojima upravljaju administratori",
    "cannotDeactivateOwnAccount": "Ne možete deaktivirati sopstveni nalog",
    "cannotDeleteOwnAccount": "Ne možete obrisati sopstveni nalog",
    "cannotDeleteSuperAdmin": "Super administratori ne mogu da se obrišu",
    "cannotModifyOwnRoles": "Ne možete menjati sopstvene uloge",
    "cannotModifyOwnSuperAdmin": "Ne možete menjati sopstveni status super administratora",
    "cannotResendSuperAdminInvitation": "Pozivnice ne mogu ponovo da se šalju super administratorima",
    "cannotResetSuperAdminPassword": "Lozinka super administratora ne može ovdje da se resetuje",
    "cannotUpdateSuperAdmin": "Super administratori ne mogu da se menjaju",
    "conflict": "Ovo već postoji",
    "counterNotFound": "Brojač nije pronađen",
    "currentPasswordIncorrect": "Trenutna lozinka nije tačna",
    "emailAlreadyVerified": "Ovaj email je već potvrđen. Možete se prijaviti.",
    "emailExists": "Ovaj email je već registrovan",
    "emailNotVerified": "Potvrdite vaš email prije prijave",
    "emailRequired": "Email je obavezan",
    "fetchActivityFailed": "Aktivnost nije mogla da se učita",
    "fetchProfileFailed": "Profil nije mogao da se učita",
    "fetchSessionsFailed": "Sesije nisu mogle da se učitaju",
    "fetchUsersFailed": "Korisnici nisu mogli da se učitaju",
    "forbidden": "Nemate dozvolu za to",
    "identifierInUse": "To korisničko ime ili email je već u upotrebi",
    "identifierRequired": "Korisničko ime ili email je obavezan",
    "invalidCredentials": "Pogrešno korisničko ime ili lozinka",
    "invalidEmail": "Neispravan format email adrese",
    "invalidInvitationToken": "Nevažeći ili istekao link pozivnice",
    "invalidResetToken": "Ovaj link za resetovanje lozinke nije važeći ili je istekao",
    "invalidVerificationToken": "Ovaj link za potvrdu nije važeći ili je istekao",
    "logoutAllFailed": "Odjava ostalih sesija nije uspjela",
    "logoutFailed": "Odjava nije uspjela",
    "newPasswordSameAsCurrent": "Nova lozinka mora da se razlikuje od trenutne",
    "noPlatformAccess": "Vaš nalog nema pristup ovoj aplikaciji",
    "notFound": "Nije pronađeno",
    "onlySuperAdminsCreateSuperAdmins": "Samo super administratori mogu da kreiraju super administratore",
    "onlySuperAdminsManageSuperAdmins": "Samo super administratori mogu da upravljaju statusom super administratora",
    "passwordAlreadySet": "Ovaj korisnik je već postavio lozinku. Umesto toga koristite resetovanje lozinke.",
    "passwordComplexity": "Lozinka ne ispunjava zahtjeve",
    "passwordMinLength": "Lozinka mora imati najmanje {{count}} karaktera",
    "passwordNotSet": "Ovaj nalog nema postavljenu lozinku",
    "passwordSetupRequired": "Morate postaviti lozinku prije prijave",
    "profileNotFound": "Profil nije pronađen",
    "registrationFailed": "Registracija nije uspjela",
    "registrationUnavailable": "Registracija nije dostupna",
    "resetPasswordFailed": "Resetovanje lozinke nije uspjelo",
    "revokeSessionFailed": "Opoziv sesije nije uspio",
    "securityCheckFailed": "Bezbjednosna provjera nije uspjela. Osvježite stranicu i pokušajte ponovo.",
    "serverError": "Došlo je do greške na našoj strani. Pokušajte ponovo.",
    "sessionNotFound": "Sesija nije pronađena",
    "tooManyLoginAttempts": "Previše pokušaja prijave. Pokušajte ponovo za {{seconds}} sekundi",
    "updateUserFailed": "Ažuriranje korisnika nije uspjelo",
    "userNotFound": "Korisnik nije pronađen",
    "usernameDerivedFromEmail": "Korisničko ime se izvodi iz emaila kada je prijava putem emaila",
    "usernameExists": "Korisničko ime već postoji",
    "usernameRequired": "Korisničko ime je obavezno",
    "verificationFailed": "Potvrda nije uspjela",
    "verificationUnavailable": "Potvrda emaila nije dostupna",
    "verifyInvitationFailed": "Pozivnica nije mogla da se provjeri",
    "accountDeactivated": "Nalog je deaktiviran",
    "accountLockedFor": "Nalog je zaključan na {{seconds}} sekundi",
    "invalidPassword": "Pogrešna lozinka",
    "invalidPasswordLocked": "Pogrešna lozinka – nalog je zaključan na {{seconds}} sekundi",
    "passwordPolicyDefault": "Lozinka mora da sadrži veliko slovo, malo slovo, broj i specijalni znak",
    "platformAccessDenied": "Pristup odbijen za ovu platformu ({{platform}})",
    "sendVerificationFailed": "Email za potvrdu nije mogao da se pošalje"
  },
  "dataTable": {
    "clearFilters": "Očisti filtere",
    "columns": "Kolone",
    "noResults": "Nema rezultata.",
    "pagination": {
      "next": "Sljedeća",
      "pageOf": "Strana {{page}} od {{pageCount}}",
      "perPage": "{{count}} / strana",
      "previous": "Prethodna",
      "showing": "Prikazano {{from}}–{{to}} od {{total}} rezultata"
    },
    "rowsSelected": "Izabrano {{selected}} od {{total}} redova.",
    "searchPlaceholder": "Pretraži...",
    "column": {
      "actions": "Radnje",
      "createdAt": "Kreirano",
      "isActive": "Status",
      "lastLoginAt": "Posljednja prijava",
      "name": "Ime",
      "roles": "Uloge",
      "username": "Korisničko ime"
    }
  },
  "forgotPassword": {
    "backToLogin": "Nazad na prijavu",
    "description": "Unesite vaš email i poslaćemo vam link za resetovanje.",
    "email": "Email",
    "emailPlaceholder": "Unesite vaš email",
    "sent": {
      "description": "Ako nalog sa ovim emailom postoji, dobićete link za resetovanje lozinke.",
      "title": "Provjerite vaš email"
    },
    "submit": "Pošalji link za resetovanje",
    "title": "Zaboravljena lozinka"
  },
  "password": {
    "error": {
      "complexity": "Lozinka ne ispunjava zahtjeve",
      "minLength": "Lozinka mora imati najmanje {{count}} karaktera"
    },
    "requirement": {
      "complexity": "Ispunjava zahtjeve složenosti",
      "minLength": "Najmanje {{count}} karaktera"
    },
    "show": "Prikaži lozinku",
    "hide": "Sakrij lozinku"
  },
  "register": {
    "button": "Napravi nalog",
    "button.loading": "Kreiranje naloga...",
    "confirmPassword": {
      "label": "Potvrdite lozinku",
      "placeholder": "Potvrdite vašu lozinku"
    },
    "description": "Unesite svoje podatke da biste napravili nalog",
    "email": {
      "label": "Email",
      "placeholder": "Unesite vaš email"
    },
    "error": {
      "failed": "Registracija nije uspjela. Pokušajte ponovo.",
      "invalidEmail": "Unesite ispravnu email adresu",
      "nameRequired": "Ime je obavezno",
      "passwordLength": "Lozinka mora imati najmanje 8 karaktera",
      "passwordMismatch": "Lozinke se ne poklapaju"
    },
    "hasAccount": "Već imate nalog?",
    "name": {
      "label": "Ime",
      "placeholder": "Unesite vaše ime"
    },
    "password": {
      "label": "Lozinka",
      "placeholder": "Unesite vašu lozinku"
    },
    "signIn": "Prijavite se",
    "success": "Registracija je uspjela! Provjerite vaš email da biste potvrdili nalog.",
    "title": "Napravite nalog"
  },
  "resetPassword": {
    "confirmPassword": "Potvrdite lozinku",
    "description": "Unesite vašu novu lozinku ispod.",
    "error": "Resetovanje lozinke nije uspjelo",
    "goToLogin": "Idi na prijavu",
    "invalid": {
      "description": "Ovaj link za resetovanje lozinke je istekao ili nije važeći. Zatražite novi.",
      "title": "Nevažeći ili istekao link"
    },
    "newPassword": "Nova lozinka",
    "passwordInvalid": "Lozinka ne ispunjava zahtjeve",
    "passwordMismatch": "Lozinke se ne poklapaju",
    "requestNew": "Zatraži novi link",
    "submit": "Resetuj lozinku",
    "success": "Lozinka je uspješno resetovana",
    "success.description": "Uskoro ćete biti preusmereni na prijavu.",
    "success.title": "Lozinka je resetovana",
    "title": "Resetovanje lozinke"
  },
  "verifyEmail": {
    "error": {
      "invalidToken": "Ovaj link za potvrdu nije važeći ili je istekao.",
      "noToken": "Nije proslijeđen token za potvrdu",
      "title": "Potvrda nije uspjela"
    },
    "goToLogin": "Idi na prijavu",
    "needAccount": "Nemate nalog?",
    "resend": {
      "button": "Ponovo pošalji email za potvrdu",
      "cancel": "Otkaži",
      "email": {
        "label": "Email adresa",
        "placeholder": "Unesite vaš email"
      },
      "emailRequired": "Unesite vaš email",
      "sending": "Slanje...",
      "submit": "Pošalji",
      "success": "Ako je vaš email registrovan, dobićete email za potvrdu."
    },
    "signUp": "Registrujte se",
    "success": {
      "description": "Vaš email je uspješno potvrđen. Sada se možete prijaviti na svoj nalog.",
      "redirect": "Preusmeravanje na prijavu...",
      "title": "Email je potvrđen!"
    }
  },
  "unsavedChanges": {
    "title": "Izađi bez čuvanja?",
    "body": "Tvoje izmjene će biti izgubljene.",
    "stay": "Ostani",
    "leave": "Izađi"
  },
  "richText": {
    "bold": "Podebljano",
    "italic": "Kurziv",
    "underline": "Podvučeno",
    "strike": "Precrtano",
    "heading": "Naslov",
    "paragraph": "Pasus",
    "bullets": "Lista sa tačkama",
    "numbers": "Numerisana lista",
    "quote": "Citat"
  }
}
